import { ScreenSize } from 'glints-aries/es';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import { useGetFeatureEnabledForCountry } from '../../common/hooks/useGetFeatureEnabledForCountry';
import { getIsLoggedIn } from '../../selectors/session';

export default function useShowMobileAppPrompt(): boolean {
  const isMobileView = useMediaQuery({ maxWidth: ScreenSize.tablet - 1 });
  const { isUseMobileAppPromptEnabled: isEnabledForCountry } =
    useGetFeatureEnabledForCountry();
  const isLoggedIn = useSelector(getIsLoggedIn);
  return isLoggedIn && isEnabledForCountry && isMobileView;
}
